import { render, staticRenderFns } from "./MemberControlH5.vue?vue&type=template&id=52d5bd0d&scoped=true"
import script from "./MemberControlH5.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberControlH5.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MemberControlH5.vue?vue&type=style&index=0&id=52d5bd0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d5bd0d",
  null
  
)

export default component.exports